<template>
  <b-overlay :show="show" rounded="md" :shown="shown()">
    <b-container id="main-container" fluid style>
      <b-row style="width: 100%; background-color: #e8e8ea" align-h="center">
        <b-col class="" cols="12">
          <nav-header ref="header"></nav-header>
        </b-col>
      </b-row>

      <b-row>
        <b-col class="cart-nav">
          <b-row
            style="width: 100%; padding-top: 70px"
            align-h="center"
            class="main-jumbotron select-header padding-top-50-small"
          >
            <b-col class="pl-0 pr-0">
              <b-row
                class="blue-text justify-content-center"
                style="color: #82c431"
                data-aos="fade-right"
                data-aos-delay="250"
                hidden
              >
                Tracker & Tracker Pro
              </b-row>

              <b-row
                class="justify-content-center pt-3 hide-when-small"
                data-aos="fade-right"
                data-aos-delay="350"
              >
                <h1
                  style="
                    max-width: 100%;
                    margin: 0 !important;
                    padding: 0 !important;
                  "
                >
                  Which Truthbrush is for you?
                </h1>
              </b-row>
              <b-row
                class="
                  justify-content-center
                  align-center
                  sub-title2
                  pt-2
                  pl-3
                  pr-3
                  pl-pr-0-sm
                  sub-title-select
                  hide-when-small
                "
                style="max-width: 700px; margin: auto !important"
                data-aos="fade-right"
                data-aos-delay="450"
              >
                Develop independent and healthy brushing habits. Reliable
                monitoring in the background, no phone needed in bathroom, no
                addictive games.
              </b-row>
            </b-col>
          </b-row>

          <b-row
            align-h="center"
            style="width: 100%; padding: 0 10%"
            class="pl-pr-0-sm pt-3 main-jumbotron no-padding-top-small"
          >


            
            
            

            



            <b-col md="6" lg="4" cols="12" class="shop-select-item">
              <b-row
                style="
                  background-color: auto;
                  position: relative;
                  cursor: pointer;
                "
                @click="gotoshop(0)"
              >
                <b-col cols="12" class="blue-shadow" style='background-color: #F5F1FF'>
                  <b-row
                    style="
                      height: 40px;
                      height: auto;
                      position: absolute;
                      top: 0px;
                      margin: 0 auto;
                      left: 50%;
                      transform: translate(-50%, 0);
                      background-color: #12b8ed;
                      text-align: center;
                      border-radius: 0 0 10px 10px;
                      width: 230px;
                    "
                  >
                    <b-col style="color: white; font-weight: 500" hidden
                      >For 1 person | For 1 year </b-col
                    >
                  </b-row>
                  <b-row>
                    <b-col cols="12" class="pt-5 pl-0 pr-0">
                      <h1
                        style="
                          max-width: 100% !important;
                          margin-bottom: 0;
                          text-align: center;
                        "
                      >
                        Truthbrush Classic
                      </h1>
                    </b-col>

                    <b-col
                      cols="12"
                      class="pt-1 pb-3 pl-0 pr-0"
                      style="height: 35px"
                      hidden
                    >
                      <b-row>
                        <b-col
                          class="pl-0 pr-0 pt-1"
                          style="height: 1.2rem; text-align: center"
                        >
                          <span
                            style="
                              padding-left: 10px;
                              height: 1.2rem;
                              vertical-align: middle;
                            "
                            ><b style="line-height: 1.2rem; font-size: 1.4rem; color: #9775FA"
                              >Starting $24.99</b
                            ></span
                          >
                        </b-col>
                      </b-row>
                    </b-col>
                    <b-col
                      cols="12"
                      class="pt-2 select-h3"
                    >
                      Advanced oral care tracking at an affordable price!  Built-in battery lasts up to 12 months<sup>5</sup>.

                    </b-col>

                    <b-col cols="12" class="pt-3 pb-1" style="text-align: center">
                      <router-link to="/select_t1">
                        <b-button
                          pill
                          variant="primary"
                          class="hub-blue btn-truthbrush pl-5 pr-5"
                          >Learn more</b-button
                        >
                      </router-link>
                    </b-col>

                    <b-col
                      cols="12"
                      class="pt-4 pb-4 pl-0 pr-0"
                      style="
                        color: #4f4f4f;
                        font-size: 20px;
                        text-align: center;
                      "
                    >
                      <b-img
                        src="img/t1-selector-b.png"
                        fluid
                        center
                        class="select_hero_img"
                      />
                    </b-col>
                    
                  </b-row>
                </b-col>
              </b-row>
            </b-col>

            <b-col md="6" lg="4" cols="12" class="shop-select-item">
              <b-row
                style="background-color: auto; cursor: pointer"
                @click="gotoshop(1)"
              >
                <b-col cols="12" class="blue-shadow" style='background-color:#EAF4FD'>
                  <b-row
                    style="
                      height: 40px;
                      height: auto;
                      position: absolute;
                      top: 0px;
                      margin: 0 auto;
                      left: 50%;
                      transform: translate(-50%, 0);
                      background-color: #12b8ed;
                      text-align: center;
                      border-radius: 0 0 10px 10px;
                      width: 230px;
                    "
                  >
                    <b-col style="color: white; font-weight: 500" hidden
                      >For 1 person | For multi-years</b-col
                    >
                  </b-row>
                  <b-row>
                    <b-col cols="12" class="pt-5 pl-0 pr-0">
                      <h1
                        style="
                          max-width: 100% !important;
                          margin-bottom: 0;
                          text-align: center;
                        "
                      >
                        Truthbrush Pro
                      </h1>
                    </b-col>

                    <b-col
                      cols="12"
                      class="pt-1 pb-3 pl-0 pr-0"
                      style="height: 35px"
                      hidden
                    >
                      <b-row>
                        <b-col
                          class="pl-0 pr-0 pt-1"
                          style="height: 1.2rem; text-align: center"
                        >
                          <span
                            style="
                              padding-left: 10px;
                              height: 1.2rem;
                              vertical-align: middle;
                            "
                            ><b style="line-height: 1.2rem; font-size: 1.4rem; color: #16B8E1"
                              >Starting at $29.99</b
                            ></span
                          >
                        </b-col>
                      </b-row>
                    </b-col>
                    

                    <b-col
                      cols="12"
                      class="pt-2 select-h3"
                    >
                    Next generation oral care tracking technology! Long lasting with replaceable batteries<sup>1</sup>.
                      
                    </b-col>
                    <b-col cols="12" class="pt-3 pb-1" style="text-align: center">
                      <router-link to="/select_t2">
                        <b-button
                          pill
                          variant="primary"
                          class="hub-blue btn-truthbrush pl-5 pr-5"
                          >Learn more</b-button
                        >
                      </router-link>
                    </b-col>
                    <b-col
                      cols="12"
                      class="pt-4 pb-4 pl-0 pr-0"
                      style="
                        color: #4f4f4f;
                        font-size: 20px;
                        text-align: center;
                      "
                    >
                      <b-img
                        src="img/pro-selector-v3.png"
                        fluid
                        center
                        class="select_hero_img"
                      />
                    </b-col>

                    
                  </b-row>
                </b-col>
              </b-row>
            </b-col>

            <b-col md="6" lg="4" cols="12" class="shop-select-item">
              <b-row
                style="background-color: auto; cursor: pointer"
                @click="gotoshop(3)"
              >
                
                <b-col cols="12" class="blue-shadow" style='background-color:#FFF8E7'>
                  <b-row
                    style="
                      height: 40px;
                      height: auto;
                      position: absolute;
                      top: 0px;
                      margin: 0 auto;
                      left: 50%;
                      transform: translate(-50%, 0);
                      background-color: #82c431;
                      text-align: center;
                      border-radius: 0 0 10px 10px;
                      width: 230px;
                    "
                  >
                    <b-col style="color: white; font-weight: 500"
                      >Pay in full & save</b-col
                    >
                  </b-row>
                  <b-row>
                    
                    <b-col cols="12" class="pt-5 pl-0 pr-0">
                      <h1
                        style="
                          max-width: 100% !important;
                          margin-bottom: 0;
                          text-align: center;
                        "
                      >
                        Multi User Bundles
                      </h1>
                    </b-col>
                    <b-col
                      cols="12"
                      class="pt-1 pb-3 pl-0 pr-0"
                      style="height: 35px"
                      hidden
                    >
                      <b-row>
                        <b-col
                          class="pl-0 pr-0 pt-1"
                          style="height: 1.2rem; text-align: center"
                        >
                          <span
                            style="
                              padding-left: 10px;
                              height: 1.2rem;
                              vertical-align: middle;
                            "
                            ><b style="line-height: 1.2rem; font-size: 1.4rem; color: #FEB60D"
                              >Trackers + Skins + Hub</b
                            ></span
                          >
                        </b-col>
                      </b-row>
                    </b-col>

                    <b-col
                      cols="12"
                      class="pt-2 select-h3"
                    >
                      Special offers for the family! Your unlocked devices deliver unlimited access to Truthbrush service!

                    </b-col>
                    <b-col cols="12" class="pt-3 pb-1" style="text-align: center">
                      <router-link to="/select_t4">
                        <b-button
                          pill
                          variant="primary"
                          class="hub-blue btn-truthbrush pl-5 pr-5"
                          >Buy Bundles</b-button
                        >
                      </router-link>
                    </b-col>

                    <b-col
                      cols="12"
                      class="pt-4 pb-4 pl-0 pr-0"
                      style="
                        color: #4f4f4f;
                        font-size: 20px;
                        text-align: center;
                      "
                    >
                      <b-img
                        src="img/bundle-selector.png"
                        fluid
                        center
                        class="select_hero_img"
                      />
                    </b-col>

                    
                  </b-row>
                </b-col>
              </b-row>
            </b-col>

           


            <b-col md="6" lg="4" cols="12" class="shop-select-item">
              <b-row
                style="background-color: auto; cursor: pointer"
                @click="gotoshop(5)"
              >
                <b-col cols="12" class="blue-shadow" style='background-color:#FEF0F4'>
                  <b-row
                    style="
                      height: 40px;
                      height: auto;
                      position: absolute;
                      top: 0px;
                      margin: 0 auto;
                      left: 50%;
                      transform: translate(-50%, 0);
                      background-color: #F27CA5;
                      text-align: center;
                      border-radius: 0 0 10px 10px;
                      width: 230px;
                    "
                  >
                    <b-col style="color: white; font-weight: 500"
                      >Plans right for your family!</b-col
                    >
                  </b-row>
                  <b-row>
                    <b-col cols="12" class="pt-5 pl-0 pr-0">
                      <h1
                        style="
                          max-width: 100% !important;
                          margin-bottom: 0;
                          text-align: center;
                        "
                      >
                        Flexible Monthly Plans
                      </h1>
                    </b-col>

                    <b-col
                      cols="12"
                      class="pt-1 pb-3 pl-0 pr-0"
                      style="height: 35px"
                      hidden
                    >
                      <b-row>
                        <b-col
                          class="pl-0 pr-0 pt-1"
                          style="height: 1.2rem; text-align: center"
                        >
                          <span
                            style="
                              padding-left: 10px;
                              height: 1.2rem;
                              vertical-align: middle;
                            "
                            ><b style="line-height: 1.2rem; font-size: 1.4rem; color: #16B8E1"
                              >As low as $5.99</b
                            ></span
                          >
                        </b-col>
                      </b-row>
                    </b-col>
                    

                    <b-col
                      cols="12"
                      class="pt-2 select-h3"
                    >
                     Start today for less, then as low as 99&#162;/mo/user. Free, new Tracker every 24 mo. Cancel anytime!
                    </b-col>
                    <b-col cols="12" class="pt-3 pb-1" style="text-align: center">
                      <router-link to="/select_t6">
                        <b-button
                          pill
                          variant="primary"
                          class="hub-blue btn-truthbrush pl-5 pr-5"
                          >View Plans</b-button
                        >
                      </router-link>
                    </b-col>
                    <b-col
                      cols="12"
                      class="pt-4 pb-4 pl-0 pr-0"
                      style="
                        color: #4f4f4f;
                        font-size: 20px;
                        text-align: center;
                      "
                    >
                      <b-img
                        src="img/truthbrushsubscription 1-min.png"
                        fluid
                        center
                        class="select_hero_img"
                      />
                    </b-col>

                    
                  </b-row>
                </b-col>
              </b-row>
            </b-col>
            

            <b-col md="6" lg="4" cols="12" class="shop-select-item">
              <b-row
                style="
                  background-color: auto;
                  position: relative;
                  cursor: pointer;
                "
                @click="gotoshop(2)"
              >
                <b-col cols="12" class="blue-shadow" style='background-color:#FFF3E7'>
                  <b-row>
                    <b-col cols="12" class="pt-5 pl-0 pr-0">
                      <h1
                        style="
                          max-width: 100% !important;
                          text-align: center;
                          padding-left: 0;
                          margin-bottom: 0;
                        "
                      >
                        Truthbrush Skins
                      </h1>
                    </b-col>

                    <b-col
                      cols="12"
                      class="pt-1 pb-3 pl-0 pr-0"
                      style="height: 35px"
                      hidden
                    >
                      <b-row>
                        <b-col
                          class="pl-0 pr-0 pt-1"
                          style="height: 1.2rem; text-align: center"
                        >
                          <span
                            style="
                              padding-left: 10px;
                              height: 1.2rem;
                              vertical-align: middle;
                            "
                            ><b style="line-height: 1.2rem; font-size: 1.4rem; color: #FB870C"
                              >New + Exclusive</b
                            ></span
                          >
                        </b-col>
                      </b-row>
                    </b-col>

                    <b-col
                      cols="12"
                      class="pt-2 select-h3"
                    >
                      Add more fun to your brushing with the popular Trushbrush skins!  Collect them all!
                    </b-col>

                    <b-col cols="12" class="pt-3 pb-1" style="text-align: center" >
                      <router-link to="/select_t3">
                        <b-button
                          pill
                          variant="primary"
                          class="hub-blue btn-truthbrush pl-5 pr-5"
                          >Explore Skins</b-button
                        >
                      </router-link>
                    </b-col>

                    <b-col
                      cols="12"
                      class="pt-4 pb-4 pl-0 pr-0"
                      style="
                        color: #4f4f4f;
                        font-size: 20px;
                        text-align: center;
                      "
                    >
                      <b-img
                        src="img/skin-selector2.png"
                        fluid
                        center
                        class="select_hero_img"
                      />
                    </b-col>
                    
                  </b-row>
                </b-col>
              </b-row>
            </b-col>

            <b-col md="6" lg="4" cols="12" class="shop-select-item">
              <b-row
                style="
                  background-color: auto;
                  position: relative;
                  cursor: pointer;
                "
                @click="gotoshop(4)"
              >
              
                <b-col cols="12" class="blue-shadow" style='background-color: #E6F9F6'>
                  <b-row>
                    <b-col cols="12" class="pt-5 pl-0 pr-0">
                      <h1
                        style="
                          max-width: 100% !important;
                          text-align: center;
                          padding-left: 0;
                          margin-bottom: 0;
                        "
                      >
                        Truthbrush Hub
                      </h1>
                    </b-col>

                    <b-col
                      cols="12"
                      class="pt-1 pb-3 pl-0 pr-0"
                      style="height: 35px"
                      hidden
                    >
                      <b-row>
                        <b-col
                          class="pl-0 pr-0 pt-1"
                          style="height: 1.2rem; text-align: center"
                        >
                          <span
                            style="
                              padding-left: 10px;
                              height: 1.2rem;
                              vertical-align: middle;
                            "
                            ><b style="line-height: 1.2rem; font-size: 1.4rem; color: #00BEA4"
                              >Connect trackers to the cloud</b
                            ></span
                          >
                        </b-col>
                      </b-row>
                    </b-col>

                    <b-col
                      cols="12"
                      class="pt-2 select-h3"
                    >
                      Truthbrush hub connects Truthbrush trackers to the internet!
                    </b-col>

                    <b-col cols="12" class="pt-3 pb-1" style="text-align: center" >
                      <router-link to="/select_t5">
                        <b-button
                          pill
                          variant="primary"
                          class="hub-blue btn-truthbrush pl-5 pr-5"
                          >Learn more</b-button
                        >
                      </router-link>
                    </b-col>

                    <b-col
                      cols="12"
                      class="pt-4 pb-4 pl-0 pr-0"
                      style="
                        color: #4f4f4f;
                        font-size: 20px;
                        text-align: center;
                      "
                    >
                      <b-img
                        src="img/hub-selector.png"
                        fluid
                        center
                        class="select_hero_img"
                      />
                    </b-col>
                    
                  </b-row>
                </b-col>
              </b-row>
            </b-col>
          </b-row>

          <b-row
            style="width: 100%; position: relative; padding-bottom: 60px; "
            align-h="center"
            class="main-jumbotron reduced-pb-0 pt-5"
            hidden
          >
            <b-col cols="12" class="pl-0 pr-0">
              <b-row
                class="blue-text justify-content-center"
                style="color: #12b8ed"
              >
                Truthbrush Skin
              </b-row>

              <b-row class="justify-content-center pt-3">
                <h1 style="max-width: 820px; color: black; text-align: center">
                  Give your Truthbrush Tracker
                </h1>
              </b-row>
              <b-row>
                <b-col>
                  <b-img src="img/newlook.png" center style="max-width: 240px">
                  </b-img>
                </b-col>
              </b-row>
              <b-row class="mt-3">
                <b-col cols="12" style="text-align: center">
                  <router-link to="/select_t3">
                    <b-button
                      pill
                      variant="primary"
                      size="lg"
                      class="hub-blue btn-truthbrush select-btn"
                      >Select your skin</b-button
                    >
                  </router-link>
                </b-col>
              </b-row>

              <b-row class="pt-2">
                <b-col class="pl-0 pr-0">
                  <b-img src="img/skin-combo.jpg" fluid center />
                </b-col>
              </b-row>
            </b-col>
          </b-row>

          <b-row class="pt-5">
            <b-col class="pl-0 pr-0" style='background-color: #BFEFE8'>
              <b-row class="justify-content-center main-jumbotron pt-5" >
                <h1 style="max-width: 100%" class="h1-font pt-3">
                  Packaging Content
                </h1>
              </b-row>
              <b-row
                class="
                  justify-content-center
                  align-center
                  pt-2
                  pl-3
                  pr-3
                  h4-font
                "
                style="
                  max-width: 700px;
                  margin: auto !important;
                  font-size: 18px;
                "
              >
                The Truthbrush consists of Tracker and Hub, both are
                required for the system to work. Each Hub can support multiple
                Trackers at the same time. Additional Hub can be added for
                expanded coverage area. If you have never purchased Truthbrush
                before, please select one of the bundles. If you already have a
                Hub and would like to purchase additional Tracker, please select
                the Tracker only option. Image for illustration only, actual
                packaging and content varies based on actual order.
              </b-row>
              <b-row class="pt-5 pb-5">
                <b-col class="pr-5 pl-5 reduced_pl_pr">
                  <b-img
                    src="/img/group-197.png"
                    style="max-height: 650px"
                    center
                    fluid
                  ></b-img>
                </b-col>
              </b-row>
            </b-col>
          </b-row>

          <b-row class="justify-content-center pt-3 main-jumbotron" style='background-color: #008573'>
            <h1 style="max-width: 100%; text-align: center; color:white " class="h1-font pt-5">
              Frequently Asked Questions
            </h1>
          </b-row>
          <b-row class="pl-5 pr-5 reduced_pl_pr main-jumbotron  pb-3" style='background-color: #008573'>
            <b-col cols="12" class="pl-0 pr-0 select-faq">
              <VueFaqAccordion
                :items="myItems"
                :activeColor="activeColorAccordian"
                :borderColor="borderColorAccordian"
                :fontColor="fontColorAccordian"
              />
            </b-col>
          </b-row>
          <b-row style="justify-content: center" class="pt-5 pb-5">
            <a href="/#/faq">Visit our FAQ section</a>
          </b-row>
          <b-row
            align-h="center"
            style="width: 100%; margin-top: 40px; margin-bottom: 60px"
          >
            <b-col
              cols="12"
              style="padding-top: 5px"
              class="pl-0 pr-0 cart-nav"
            >
              <ol style="color: #4f4f4f; font-size: 10px; padding-left: 15px">
                <li style="font-size: 10px">
                  Standard CR1620 battery is used. Openning and closing tracker
                  housing requires special tool which is provided with purchase.
                  Battery life is lab tested and last 6-7 months under normal
                  usage pattern and excellent Bluetooth and Wifi connection. Your battery life may vary based on actual
                  usage pattern.
                </li>
                <li style="font-size: 10px">
                  Wireless range for the Tracker pro is longer than that of the
                  Truthbrush Tracker. The piezo buzzer in the Pro version is
                  louder than that of the Truthbrush version.
                </li>
                <li style="font-size: 10px">
                  Terms and conditions apply, subject to change and terms of
                  services without prior notification. Free data storage and
                  tracking service are based on the tracker's working life,
                  which may vary based on actual usage pattern and may be
                  subject to normal wear.
                </li>
                <li style="font-size: 10px">
                  A Truthbrush Hub device is required for trackers to work. Each
                  Hub can support multiple trackers and tracker Pros. Hub is
                  sold separately. Skin purchase is optional and costs extra.
                </li>
                <li style="font-size: 10px">
                  Tested under good wireless connectivity condition and is based
                  on continuous tracking with two efficient brushings a day.
                  Your battery life might be shorter or longer depending on your
                  actual usage pattern.
                </li>
                <li style="font-size: 10px">
                  Battery usage estimated based on two brushing sessions a day, each lasting 120 seconds.
                </li>
                <li style="font-size: 10px">
                  Skin design varies from time to time and is subject to
                  inventory. Skin purchase is optional and costs extra.
                </li>
                <li style="font-size: 10px">
                  Subject to inventory availability. One-time activation fee is required and is charged per tracker up front. 1 Hub is included in each pay-as-you-go plan. Your subscription fee is charged monthly and can be cancelled at anytime.
                </li>
              </ol>
            </b-col>
          </b-row>
        </b-col>
      </b-row>

      <b-row style="width: 100%">
        <nav-footer></nav-footer>
      </b-row>
    </b-container>
  </b-overlay>
</template>

<script>
import NavHeader from "./../components/NavHeader";
import NavFooter from "./../components/NavFooter";
import VueFaqAccordion from "vue-faq-accordion";
import storage from "../storage";
//import { getReviews } from "../api/store.js";

export default {
  name: "ProductSelect",
  components: {
    NavHeader,
    NavFooter,
    VueFaqAccordion,
  },
  data() {
    return {
      t1rating: 0,
      t2rating: 0,
      t1count: 0,
      t2count: 0,
      paginationColor: "#12B8ED",
      activeColorAccordian: "white",
      borderColorAccordian: "#26C8B2",
      fontColorAccordian: "white",
      show: false,
      myItemsPro: [
        {
          title: "More Information",
          value:
            "The Truthbrush tracker is a small, decorative device that fits on any manual or electric toothbrush. The tracker records motion activity when the toothbrush is used. This activity is displayed in the Truthbrush mobile application. It displays daily activity like a fitness tracker and includes time of day, brush duration, mouth coverage, and movement analysis. The tracker also has a configurable beep timer to help build proper habits.",
        },
      ],
      myItemsTracker: [
        {
          title: "More Information",
          value:
            "The Truthbrush tracker is a small, decorative device that fits on any manual or electric toothbrush. The tracker records motion activity when the toothbrush is used. This activity is displayed in the Truthbrush mobile application. It displays daily activity like a fitness tracker and includes time of day, brush duration, mouth coverage, and movement analysis. The tracker also has a configurable beep timer to help build proper habits.",
        },
      ],
      myItems: [
        {
          title: "1. What is a Truthbrush tracker?",
          value:
            "The Truthbrush tracker is a small, decorative device that fits on any manual or electric toothbrush. The tracker records motion activity when the toothbrush is used. This activity is displayed in the Truthbrush mobile application. It displays daily activity like a fitness tracker and includes time of day, brush duration, mouth coverage, and movement analysis. The tracker also has a configurable beep timer to help build proper habits.",
        },
        {
          title: "2. What is the Truthbrush hub?",
          value:
            "The Truthbrush hub is a unit that plugs into any wall outlet. The hub connects to the local Wi-Fi and routes data from all Truthbrush trackers within a 30 ft. range to the Truthbrush service. The hub collects data passively in the background.",
        },

        {
          title:
            "3. Is there a monthly fee after purchasing the tracker and hub?",
          value: "Only Truthbrush Pay-as-you-Go users pay a recurring service fee to maintain the operation of their tracker and hub. For all other users who purchased Truthbrush in full, there is no additional fee to pay to use the Truthbrush app. The Truthbrush app and tracking service are unlocked and free to use with your full purchase.",
        },

        {
          title: "4. Does it work for electric toothbrush?",
          value: "Yes. The Tracker fits on and work for electric toothbrush.",
        },

        {
          title:
            "5. Do I need a separate Hub if I own both the Truthbrush Pro and the Truthbrush tracker?",
          value:
            "No. The Hub is compatible with both the Truthbrush tracker and the Truthbrush Pro.",
        },
        {
          title: "6. Do I need more than one hub?",
          value:
            "The hub is designed to accommodate multiple Truthbrush trackers. The hub will collect data from all trackers within 30 ft. Multiple hubs can be used in large homes where the bathrooms might be spread out.",
        },
        {
          title: "7. Does my phone need to be in the bathroom when I brush?",
          value:
            "No, Truthbrush is specifically designed to avoid bringing a phone into the bathroom or the need to open an any app. Your phone can be turned off and it will not impact the ability for Truthbrush to collect data. Parents do not want their kids looking at the phone in the bathroom and the data can never be reliably collected when the phone is required.",
        },
        {
          title: "8. Do I need to start the tracker when I brush?",
          value:
            "No, Truthbrush is designed so that you simply pick up the toothbrush and brush as you normally do, there are no stop or start buttons! The tracker will wake up on its own when you list the toothbrush and start recording. Truthbrush can tell the difference between toothbrushing activity and simply applying toothpaste or cleaning. The resulting data will reflect actual brush activity.",
        },

        {
          title: "9. Do I need to stop the tracker after brushing is complete?",
          value:
            "No, Truthbrush will detect that motion is idle and will then upload brushing data to server and go to sleep mode.",
        },

        {
          title: "10. Can multiple trackers work at the same time?",
          value:
            "Yes! Multi-tracker multi-user at the same time, with data collection handled by the hub seamlessly.",
        },
      ],
    };
  },
  methods: {
    enableNavButton() {
      const width =
        window.innerWidth ||
        document.documentElement.clientWidth ||
        document.body.clientWidth;
      console.log(width);
      if (width > 900) {
        return true;
      } else {
        return false;
      }
    },
    gotoshop(index) {
      if (index == 0) {
        window.location.href = "/#/select_t1";
      } else if (index == 1) {
        window.location.href = "/#/select_t2";
      } else if (index == 2) {
        window.location.href = "/#/select_t3";
      } else if (index == 3){
        window.location.href = "/#/select_t4";
      }else if (index == 4){
        window.location.href = "/#/select_t5";
      }else if (index == 5){
        window.location.href = "/#/select_t6";
      }
    },
    shown() {},
  },
  mounted() {
    storage.clearstorestate();
    storage.processCoupon();
    storage.saveCart2Store(this);
    
    /*
    var context = this;
    getReviews()
      .then((res) => {
        context.t1count = res.data[0].totalcount;
        if (context.t1count > 0) {
          context.t1rating = res.data[0].totalstar / context.t1count;
        } else {
          context.t1rating = 0;
        }
        this.$refs.t1reviewpanel.update(
          context.t1rating,
          context.t1count,
          0,
          1,
          "t1"
        );

        context.t2count = res.data[1].totalcount;
        if (context.t2count > 0) {
          context.t2rating = res.data[1].totalstar / context.t2count;
        } else {
          context.t2rating = 0;
        }
        this.$refs.t2reviewpanel.update(
          context.t2rating,
          context.t2count,
          0,
          1,
          "t2"
        );
      })
      .catch(function () {});
    */
  },
};
</script>

<style lang="scss">
.skin_caousel {
  width: 100%;
  max-width: 160px !important;
}

.moreinfo .accordion__value {
  padding-left: 0 !important;
  padding-right: 0 !important;
}
.moreinfo {
  padding-left: 0 !important;
  padding-right: 0 !important;
  .accordion__title {
    padding-top: 0 !important;
  }
}

.h1-skin-text {
  font-size: 32px;
  font-weight: 800;
}

.shop-select-item {
  margin-top: 25px;
}

.blue-shadow {
  border-radius: 5px;
  border: 2px solid transparent;

  //box-shadow: 1px 1px 2px rgba(99, 193, 235, 0.4);
}

.blue-shadow:hover {
  border-radius: 5px;
  border: 2px solid #12b8ed;
  box-shadow: 1px 1px 2px rgba(99, 193, 235, 0.4);
}

.spec-line {
  text-align: center;
  font-size: 16px;
  padding-top: 5px;
  padding-bottom: 5px;

  hr {
    border-top: 2px solid rgba(99, 193, 235, 0.4);
  }
}
.select-h2 {
  color: #4f4f4f;
  font-size: 20px;
  text-align: center;
}

.VueCarousel-navigation button {
  color: #12b8ed !important;
  font-size: 22px;
}
.select-h3 {
  text-align: center;
}

.select-btn {
  margin-bottom: 40px;
}

.accordion p {
  font-size: 20px !important;
}

@media (max-width: 1019px) {
  .hide-when-919 {
    display: none !important;
  }

  .show-when-919 {
    display: auto !important;
  }
}

@media (min-width: 1020px) {
  .hide-when-919 {
    display: auto !important;
  }

  .show-when-919 {
    display: none !important;
  }
}

@media (max-width: 1199px) {
  
}
@media (max-width: 768px) {
  .shop-select-item {
  padding-left:0;
  padding-right: 0;
}
  .no-padding-top-small{
    padding-top:0!important;
  }
  .padding-top-50-small{
    padding-top:50px!important;
  }
  .faq {
    padding: 0 20px !important;
  }
  .select-nav {
    padding-left: 0 !important;
  }
  .select-header {
    padding-bottom: 0 !important;
  }

  .hide-when-small {
    display: none !important;
  }

  .select-h2 {
    font-size: 15px !important;
    padding-top: 15px;
    padding-left: 0;
    padding-right: 0;
  }
  .select-h3 {
    font-size: 14px;
    padding-left: 0;
    padding-right: 0;
    text-align: center;
  }
  .accordion p {
    font-size: 16px !important;
  }

  .select-btn {
    line-height: 1;
    margin-bottom: 30px;
  }

  .pl-pr-0-sm {
    padding-left: 0 !important;
    padding-right: 0 !important;
  }

  .sub-title-select {
    font-size: 15px !important;
  }
}

.select-faq .accordion__toggle-button::after, .select-faq .accordion__toggle-button::before {
  background-color: white!important;
}

.abouthero {
  background-color: black;
}
.spec .col-12 {
  text-align: center;
}
@media (max-width: 768px) {
  .padding-top-when-small {
    padding-top: 15px;
  }
}
@media (max-width: 1199px) {
  .aboutmaintext {
    color: black;
    font-size: 20px;
    padding-left: 5%;
    padding-right: 5%;
  }
  .featuretitle {
    font-size: 20px !important;
    padding-bottom: 10px;
  }
  .featuredescription {
    color: #696871;
    font-size: 14px !important;
    padding-bottom: 25px;
  }
  .no-v-padding-small {
    padding-top: 0 !important;
  }
  .reduce-font-small {
    font-size: 24px !important;
  }
}
@media (max-width: 768px) {
  .trackerfeature,
  .trackerfeature > .row > .col-sm-6 > .row > .col {
    padding-left: 0 !important;
    padding-right: 0 !important;
  }
  .reduced-padding-top {
    padding-top: 30px !important;
  }
  .trackerfeature > .row > .col-md-6 > .row > .col {
    padding-left: 0 !important;
    padding-right: 0 !important;
  }
}
@media (min-width: 1200px) {
  .aboutmaintext {
    color: black;
    font-size: 24px;
    padding-left: 15%;
    padding-right: 15%;
  }
}
.productcell {
  border-radius: 20px;
  background-color: #f0f4f5;
  width: 100%;
  height: 100%;
}
.productcellwhole:hover {
  border: 2px solid #2ebfde !important;
  cursor: pointer;
  border-radius: 20px;
}
.productcellwhole {
  border: 2px solid white !important;
  cursor: pointer;
  border-radius: 20px;
}
.position-absolute {
  position: fixed !important;
}
.b-overlay .spinner-border {
  color: #2ebfde !important;
}
.featuretitle {
  color: #19191b;
  font-size: 24px;
  padding-bottom: 10px;
}
.featuredescription {
  color: #696871;
}
.breadcrumb-item a {
  color: #05c5ee;
}
.breadcrumb-item {
  font-size: 16px;
}
.breadcrumb {
  background-color: transparent !important;
}
.overlay-blur {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  z-index: 1;
  color: rgba(130, 130, 130, 0.5);
  font-size: 50px;
  text-align: center;
  line-height: 100px;
  box-shadow: 0 3px 5px rgba(0, 0, 0, 0.3);
}
.underline-blue {
  border: 2px solid;
  border-color: #05c5ee;
  padding: 0px;
}
.b-overlay .spinner-border {
  color: #2ebfde !important;
}
@media (max-width: 1199px) {
  .cart-nav {
    padding: 0.5rem 15px !important;
  }
  .hide-when-small-1200 {
    display: none !important;
  }
}
@media (min-width: 1200px) {
  .cart-nav {
    padding-left: calc(50% - 600px + 45px) !important;
    padding-right: calc(50% - 600px + 45px) !important;
  }
  .hide-when-big-1200 {
    display: none;
  }
}

@media only screen and (min-width: 1440px) {
  .cart-nav {
    padding-left: calc(50% - 720px + 45px) !important;
    padding-right: calc(50% - 720px + 45px) !important;
  }
  .b-nav-dropdown ul {
    display: none !important;
  }
}

.review-stars {
  width: 20px;
  margin-right: 2px;
  vertical-align: top;
}

.breadcrumb {
  padding-left: 0.5rem;
}
a {
  color: #12b8ed;
}
.product-select-box {
  border-radius: 5px;
  border: 4px solid;
  border-color: #bdbdbd;
  background-color: white;
}
.product-select-box2 {
  border-radius: 5px;
  border: 4px solid;
  border-color: #12b8ed;
  background-color: white;
}
hr {
  border-top: 1px solid #bdbdbd;
}
.faq-wrapper {
  max-width: 100% !important;
}
.accordion {
  border: 0px solid !important;
}
.accordion__title-text {
  font-size: 24px !important;
  text-align: left !important;
}

@media (max-width: 1100px) and (min-width: 1070px) {
  .select-h3 {
    min-height: 70px;
  }
}

@media (max-width: 768px) {
  #my-modal {
    padding-left: 0 !important;
  }

  .reduced_pl_pr {
    padding-left: 0 !important;
    padding-right: 0 !important;
  }
  .accordion__title {
    padding-left: 0 !important;
    padding-right: 0 !important;
  }
  .h1-font {
    font-size: 28px !important;
    font-weight: 600 !important;
  }
  .h2-font {
    font-size: 24px !important;
  }
  .h3-font {
    font-size: 20px !important;
    font-weight: 600 !important;
  }
  .h4-font {
    font-size: 16px !important;
    text-align: left !important;
    width: 100%;
  }
  .accordion__title-text {
    font-size: 16px !important;
    text-align: left !important;
  }
  .image-side-2-side {
    max-height: 200px !important;
    max-width: 50%;
  }
  .full-width {
    width: 100% !important;
  }
  .accordion__toggle-button {
    text-align: left !important;
  }
}
.blue-button,
.blue-button:hover {
  background-color: #12b8ed;
  border: none;
  padding: 12px 60px;
}

.full-width.blue-button {
  width: 100%;
  max-width: 500px;
  height: 60px;

  span {
    font-size: 18px;
  }
}
.select-nav .accordion__title {
  padding-bottom: 0 !important;
}

.underlinestyle {
  border-bottom: 2px solid #12b8ed;
}
</style>